export function resolveCreationTarget(
  projects: Array<{ id: string }>,
  preferredProjectId?: string | null,
):
  | { kind: "create-project" }
  | { kind: "selected"; projectId: string }
  | { kind: "choose"; preferredProjectId?: string } {
  if (!projects.length) return { kind: "create-project" };
  const preferred = projects.find((p) => p.id === preferredProjectId);
  if (projects.length === 1)
    return { kind: "selected", projectId: projects[0].id };
  return preferred
    ? { kind: "choose", preferredProjectId: preferred.id }
    : { kind: "choose" };
}
